import { catchError, map } from 'rxjs/operators';
import { AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription, throwError } from 'rxjs';

import { AbstractFormComponent } from './form.component';
import { CampaignId } from '../../../module/campaign-util/shared/campaign-id';
import { EventBus } from '../../event/bus';
import { ICrudForm } from '../form/crud-form.interface';
import { UrlBuilder } from '../api/url-builder';

export abstract class AbstractPresetFormComponent extends AbstractFormComponent implements OnInit, AfterViewInit, OnDestroy {

  protected routeChangeSubscription: Subscription;

  constructor(formBuilder: ICrudForm,
              httpClient: HttpClient,
              toastrService: ToastrService,
              urlBuilder: UrlBuilder,
              router: Router,
              route: ActivatedRoute,
              protected campaignId: CampaignId,
              protected eventBus: EventBus) {
    super(formBuilder, httpClient, toastrService, router, route, urlBuilder);
  }

  ngOnInit(withRouteChangeSubscribe: boolean = true): void {
    super.ngOnInit();
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.eventBus.release();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();

    if (this.formMode === 'update') {
      this.loadingPromise = this.populate().subscribe();
    }
  }

  populate(forceId?: number): Observable<any> {
    this.eventBus.emit('preset:loading', true);
    return super.populate(forceId).pipe(
      map(
        (response: any) => {
          this.eventBus.emit('preset:loading', false);
          return response;
        }
      ),
      catchError((error: any) => {
        this.eventBus.emit('preset:loading', false);
        return throwError(error);
      })
    );
  }

  protected onSubmit(response: any): void {
    this.toastrService.success('Saved');
    this.eventBus.emit('preset:saved');
  }
}
